import _globalThis2 from "../internals/global-this";
import _functionUncurryThis from "../internals/function-uncurry-this";
import _functionUncurryThisAccessor from "../internals/function-uncurry-this-accessor";
import _toIndex from "../internals/to-index";
import _arrayBufferNotDetached from "../internals/array-buffer-not-detached";
import _arrayBufferByteLength from "../internals/array-buffer-byte-length";
import _detachTransferable from "../internals/detach-transferable";
import _structuredCloneProperTransfer from "../internals/structured-clone-proper-transfer";
var exports = {};
var _globalThis = _globalThis2;
var uncurryThis = _functionUncurryThis;
var uncurryThisAccessor = _functionUncurryThisAccessor;
var toIndex = _toIndex;
var notDetached = _arrayBufferNotDetached;
var arrayBufferByteLength = _arrayBufferByteLength;
var detachTransferable = _detachTransferable;
var PROPER_STRUCTURED_CLONE_TRANSFER = _structuredCloneProperTransfer;
var structuredClone = _globalThis.structuredClone;
var ArrayBuffer = _globalThis.ArrayBuffer;
var DataView = _globalThis.DataView;
var min = Math.min;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataViewPrototype = DataView.prototype;
var slice = uncurryThis(ArrayBufferPrototype.slice);
var isResizable = uncurryThisAccessor(ArrayBufferPrototype, "resizable", "get");
var maxByteLength = uncurryThisAccessor(ArrayBufferPrototype, "maxByteLength", "get");
var getInt8 = uncurryThis(DataViewPrototype.getInt8);
var setInt8 = uncurryThis(DataViewPrototype.setInt8);
exports = (PROPER_STRUCTURED_CLONE_TRANSFER || detachTransferable) && function (arrayBuffer, newLength, preserveResizability) {
  var byteLength = arrayBufferByteLength(arrayBuffer);
  var newByteLength = newLength === undefined ? byteLength : toIndex(newLength);
  var fixedLength = !isResizable || !isResizable(arrayBuffer);
  var newBuffer;
  notDetached(arrayBuffer);
  if (PROPER_STRUCTURED_CLONE_TRANSFER) {
    arrayBuffer = structuredClone(arrayBuffer, {
      transfer: [arrayBuffer]
    });
    if (byteLength === newByteLength && (preserveResizability || fixedLength)) return arrayBuffer;
  }
  if (byteLength >= newByteLength && (!preserveResizability || fixedLength)) {
    newBuffer = slice(arrayBuffer, 0, newByteLength);
  } else {
    var options = preserveResizability && !fixedLength && maxByteLength ? {
      maxByteLength: maxByteLength(arrayBuffer)
    } : undefined;
    newBuffer = new ArrayBuffer(newByteLength, options);
    var a = new DataView(arrayBuffer);
    var b = new DataView(newBuffer);
    var copyLength = min(newByteLength, byteLength);
    for (var i = 0; i < copyLength; i++) setInt8(b, i, getInt8(a, i));
  }
  if (!PROPER_STRUCTURED_CLONE_TRANSFER) detachTransferable(arrayBuffer);
  return newBuffer;
};
export default exports;